import { render, staticRenderFns } from "./special-instruction.vue?vue&type=template&id=51eae691&"
import script from "./special-instruction.vue?vue&type=script&lang=ts&"
export * from "./special-instruction.vue?vue&type=script&lang=ts&"
import style0 from "./special-instruction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports